<template>
  <div class="leaveWords" style="width: 100%; height:100%; display: flex;align-items: center;flex-direction: column;justify-content: space-between;">
    <div v-show="showContentForm" style="width:80%;background:white;padding-top: 200px;">
      <p style="margin-bottom: 20px;font-size: 24px;">留言</p>
      <el-form :model="dataForm" label-width="0px" class="demo-ruleForm">
        
        <el-input type="textarea" :rows="12" v-model="dataForm.leaveWords" style="font-size: 24px;"></el-input>
      
        <div class="leaveWords1">
          <el-button type="primary" @click="imageCheckShow = true">立即提交</el-button>
        </div>
      </el-form>
    </div>
    <div v-show="showSuccessText" style="width:80%;background:white;text-align: center;font-size: 16px;padding: 100px 0;">
      {{'您的问题已记录，并通过手机短信方式发送给客服，我们会在24小时内回复您，感谢您信任；' + num + '秒后关闭'}}
    </div>
    <div class="leaveWordsb1">
      <div class="leaveWordsbto1">
        <div class="leaveWordsbto11">
          <router-link to="/" exact>{{ testList[0] }}</router-link>
        </div>
        <div class="leaveWordsbto11">
          <router-link to="/looplay" class="one_chanp" exact>{{testList[1]}}</router-link>
        </div>
        <div class="leaveWordsbto11">
          <router-link to="/#" exact>{{ testList[7] }}</router-link>
          </div>
        <div class="leaveWordsbto11">
          <router-link to="/about" exact>{{ testList[5] }}</router-link>
        </div>
        <div class="leaveWordsbto11">
          <router-link to="/#" exact class="halababy_app_1">{{ testList[8] }}</router-link>
        </div>
      </div>
      <div class="leaveWordsbto2"></div>
      <div class="leaveWordsbto1">
        <div class="leaveWordshalababy_app_3">
        </div>
        <div class="leaveWordshalababy_app_3">
          <router-link to="/halababy" exact>{{ testList[2] }}</router-link>
          <router-link to="/looplay" exact>{{ testList[3] }}</router-link>
          <router-link to="/uoofox" exact>Uoofox</router-link>
        </div>
        <div class="leaveWordshalababy_app_3">
          <router-link to="/spreader" exact>开发者</router-link>
          <router-link to="/spreader/login" exact>推广者</router-link>
        </div>
        <div class="leaveWordshalababy_app_3">
          <router-link to="/wx/leaveWords" exact>留言反馈</router-link>
        </div>
        <div class="leaveWordshalababy_app_3">
          <router-link to="/privacyPolicy" exact>{{ testList[9] }}</router-link>
          <router-link to="/protocol" exact>{{ testList[10] }}</router-link>
          <router-link to="/copyright" exact>{{ testList[11] }}</router-link>
        </div>
      </div>
      <div class="leaveWordsbto2"></div>
      <div class="leaveWordshalababy_app_4">
        <p> Copyright 2019 - 2029 | All Rights Reserved IOOFOX 深圳市云方程数据技术有限公司 | <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2022061985号</a></p>
      </div>
    </div>

    <el-dialog
      top="5%"
      class="imgCheckClass"
      :visible.sync="imageCheckShow"
      :show-close="false"
      width="310px">
      <div >
          <slide-verify :l="42"
            :r="10"
            :w="310"
            :h="155"
            slider-text="向右滑动"
            @success="onSuccess"
            @fail="onFail"
            @refresh="onRefresh"
            ></slide-verify>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import wxlogin from 'vue-wxlogin';

export default {
  name: "leaveWords",
  components: {
    wxlogin
  },
  created() {
  },
  destroyed: function () {
  },
  mounted: function () {
    this.telCodeInterval = null;
    //获取微信code
    this.code = this.$route.query.code;
    this.getText('zh');
    this.showSuccessText = false;
    this.showContentForm = true;
    this.num = 5;
    
    //人机验证
    this.imageCheckShow = false;
  },
  methods: {
    onSuccess(){
      this.imageCheckShow = false;
      this.submitForm();
      console.log("onSuccess")
    },
    onFail(){
      this.imageCheckShow = true;
      console.log("onFail")
    },
    onRefresh(){
      console.log("onRefresh")
    },

    submitForm(){
      const loading = this.$loading({
        lock: true,
        text: '正在提交!',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      let data = {
        content: this.dataForm.leaveWords,
        code: this.code == undefined?'':this.code,
      }
      this.$spost("/wx/officialaccounts/leaveWords", data).then((res) => {
        if(res.status == 200){
          // this.$message('您的问题已记录，并通过手机短信方式发送给客服，我们会在24小时内回复您，感谢您信任；');
          this.showSuccessText = true;
          this.showContentForm = false;
          this.telCodeInterval = setInterval(()=>{
              if(this.num == 0){
                clearInterval(this.telCodeInterval);
                this.$router.push({
                  path: "/",
                });
              }else{
                this.num = this.num - 1;
              }
            },1000);
        }else{
          this.$message(res.message);
        }
        loading.close();
      });
    },
    //获取文本
    getText(type) {
      this.$post("/halababy/loofox/text", { pageNum: 6 }).then((res) => {

        if (type == "zh") {
          let arr = new Array();
          for(var index in res.data){
            arr.push(res.data[index]["content"]);
          }
          this.testList = arr;
        } else {
          let arr = new Array();
          for(var index in res.data){
            arr.push(res.data[index]["contentEn"]);
          }
          this.testList = arr;
        }
      });
    },
  },
  data() {
    return {
      dataForm:{
        leaveWords: '',
      },
      testList:[],
      showContentForm:true,
      imageCheckShow:false,
      showSuccessText:false,
      num:this.num,
    };
  },
};
</script>

<style>
.leaveWords{
  /* background: url('../../assets/spreader/background.jpg') no-repeat center center; */
}
.leaveWords1{
  margin: 40px 0 0 0;
}
.leaveWords1 button{
  float: right;
}
.leaveWordsb1 {
  width: 100%;
  background-color: rgb(0, 0, 0);
  display: flex;
  flex-direction: column;
}
.leaveWordsbto1 {
  width: 100%;
  margin: auto;
  display: flex;
  justify-self: start;
  text-align: center;
}
.leaveWordsbto11 {
  width: 20%;
  
}
.leaveWordsbto11 a {
  color: #ffffff;
  text-decoration: none;
  
  /* height: 93px; */
  line-height: 50px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.leaveWordsbto2 {
  width: 100%;
  height: 1px;
  background: #ffffff;
  opacity: 0.3;
}
.leaveWordshalababy_app_3{
  width: 20%;
}
.leaveWordshalababy_app_3 a{
  color: #929292;
  text-decoration: none;
  line-height: 50px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  display: block;
}
.leaveWordshalababy_app_4{
  display: table-cell;
  height: 80px;
  line-height: 80px;
  color: #ffffff;
  font-size: 10px;
  text-align: center;
}
.leaveWordshalababy_app_4 a{
  text-decoration: none;
  color: #ffffff;
}
.imgCheckClass .el-dialog__body{
  padding: 0;
}
.imgCheckClass .el-dialog__header{
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/leaveWords/leaveWords.vue